import { LoginOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Menu } from "antd";
import React, { useEffect, useState, useContext } from "react";
import styles from "../../services/styles";
import { getSideMenuForUser, sideMenuItensIconsStyle } from "./Menus";
import menus from "./Menus";
import { Link, useLocation } from "react-router-dom";
import GeneralContext from "../../context/GeneralContext/GeneralContext";
import { displayMessage } from "../../helpers/messages";

const { COLORS } = styles;

export default function DrawerMenu() {
  const location = useLocation();

  const {
    setLoggedUser,
    loggedUser,
  } = useContext(GeneralContext);

  const [visible, setVisible] = useState(false);
  const [menu_selected_keys, setMenuSelectedKeys] = useState([]);

  // Itens de menu filtrados pelo papel do usuário logado
  const sideMenuItens = getSideMenuForUser(loggedUser?.type);

  const menuOptions = [
    ...sideMenuItens,
    ...menus.adminSideMenuItens,
    ...menus.topMenuItens
  ];

  useEffect(() => {
    selectMenuOnLoading();
  }, [location]);

  const selectMenuOnLoading = () => {
    let pathOption = window.location.pathname;
    if (pathOption === '/') {
      setMenuSelectedKeys([sideMenuItens[0]?.key].filter(Boolean));
      return;
    }

    const index = pathOption.indexOf('/', 1);

    if (index > 0) {
      pathOption = pathOption.substring(0, index);
    }

    const foundCurrentOption = menuOptions.find(e => e.key === pathOption);

    if (foundCurrentOption) {
      setMenuSelectedKeys([foundCurrentOption.key]);
    }
  };

  const handleOnClickLogout = () => {
    setLoggedUser(null);
    setVisible(false);
  };

  const handleOnClickItemMenu = e => {
    setMenuSelectedKeys([e.key]);
    setVisible(false);
  };

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  const listMenuItens = [
    ...menuOptions.map(item => ({
      key: item.key,
      icon: (
        <div style={{ color: COLORS.PRIMARY }}>
          {item.icon}
        </div>
      ),
      label: (
        <Link
          style={{
            color: COLORS.PRIMARY,
            fontSize: 16,
            fontWeight: 500,
          }}
          to={item.key}
        >
          <span>{item.title}</span>
        </Link>
      )
    })),
    {
      key: '/login',
      icon: <LoginOutlined style={{ ...sideMenuItensIconsStyle, color: COLORS.PRIMARY }} />,
      label: (
        <Link
          style={{
            color: COLORS.PRIMARY,
            fontSize: 16,
          }}
          to={'/login'}
          onClick={handleOnClickLogout}
        >
          <span>{displayMessage('LOGOUT')}</span>
        </Link>
      )
    }
  ];

  return (
    <>
      <Button
        type="primary"
        icon={<MenuOutlined />}
        onClick={showDrawer}
        style={{
          position: 'fixed',
          top: 16,
          left: 16,
          zIndex: 999,
          background: COLORS.PRIMARY,
          borderColor: COLORS.PRIMARY,
        }}
      />
      <Drawer
        title="Menu"
        placement="left"
        onClose={onClose}
        open={visible}
        bodyStyle={{ padding: 0 }}
      >
        <Menu
          mode="inline"
          selectedKeys={menu_selected_keys}
          onSelect={handleOnClickItemMenu}
          items={listMenuItens}
        />
      </Drawer>
    </>
  );
}



